
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Header from '../../../Header/Header';
import { CommonPageHeading } from '../../../CommonUtils/CommonHeading/CommonPageHeading';
import * as jnb from 'react-bootstrap';
import { config } from '../../../CommonUtils/CommonUrl/CommonUrls';
import { CommonAxiosGet } from '../../../CommonUtils/CommonAxios/CommonAxios';
import { useQuery } from '@tanstack/react-query';
export default function EstablishmentReport() {

    let location = useLocation();
    let data = location?.state?.data
    const [paymentStatusData, setpaymentStatusData] = useState()
    let val = data?.est_reg_id
    // const getPaymentFunction = () => {
    //     let val = data?.est_reg_id
    //     let villUrl = config.url.BOC_URL + "cess-payment-status?est_reg_id=" + val;
    //     CommonAxiosGet(villUrl).then((response) => {
    //         if (response?.data.status === true) {
    //             setpaymentStatusData(response.data.cess_payment[0])
    //         }
    //         else {
    //             setpaymentStatusData([])
    //         }
    //     });
    // };
    const { data: PaymentData } = useQuery({
        queryKey: ['GetPaymentFunction', val],
        queryFn: () => CommonAxiosGet(config.url.BOC_URL + 'cess-payment-status?est_reg_id=' + val),
        staleTime: 5 * 60 * 1000,
        // enabled: !!org_id, // Only fetch if org_id is truthy
    });
    const [transactionData, settransactionData] = useState()
    // const getTransactionFunction = () => {
    //     let val = data?.est_reg_id
    //     let villUrl = config.url.BOC_URL + "cess-payment-transactions?est_reg_id=" + val;
    //     CommonAxiosGet(villUrl).then((response) => {
    //         if (response?.data.status === true) {
    //             settransactionData(response.data.cess_payment_transactions)
    //         }
    //         else {
    //             settransactionData([])
    //         }
    //     });
    // };
    
    const { data: TransactionFunction } = useQuery({
        queryKey: ['GetTransactionFunction', val],
        queryFn: () => CommonAxiosGet(config.url.BOC_URL + 'cess-payment-transactions?est_reg_id=' + val),
        staleTime: 5 * 60 * 1000,
        // enabled: !!org_id, // Only fetch if org_id is truthy
    });

    useEffect(() => {
        if (PaymentData?.data?.status === true) {
            setpaymentStatusData(PaymentData.data.cess_payment[0]);
        } else if (PaymentData) {
            setpaymentStatusData([])
        }
    }, [PaymentData]);
    useEffect(() => {
        if (TransactionFunction?.data?.status === true) {
            settransactionData(TransactionFunction.data.cess_payment_transactions)
        } else if (TransactionFunction) {
            settransactionData([])
        }
    }, [TransactionFunction]);
    // useEffect(() => { getPaymentFunction(); getTransactionFunction() }, [])
    return (
        <React.Fragment>
            <Header />
            <div className="main_section"> </div>
            <CommonPageHeading heading="Establishment Report" />
            <jnb.Container className="outer-page-content-container">
                <div className="table-responsive" >
                    <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
                        style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }}
                    >
                        <thead>
                            <tr>

                                <td colSpan={3} style={{ textAlign: "center", fontSize: "15px", backgroundColor: "#ebf6f7" }}>
                                    Name of the Establishment - &nbsp;
                                    <label>{data?.establishment_name} (  {data?.est_reg_id})</label>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <React.Fragment>
                                <tr>
                                    <td><label>Location Details:</label></td>
                                    <td><label>Addresss Details:</label></td>
                                    <td><label>Manager Details:</label></td>
                                </tr>
                                <tr>
                                    <td>
                                        {data?.postal_address}, Door No-{data?.postal_door_no} ,
                                        {data?.postal_village_name},
                                        {data?.postal_mandal_name} ,
                                        {data?.postal_district_name} dist.,
                                        {data?.postal_pincode}
                                    </td>
                                    <td>
                                        {data?.permanent_address}, Door No-{data?.permanent_door_no} ,
                                        {data?.permanent_village_name},
                                        {data?.permanent_mandal_name} ,
                                        {data?.permanent_district_name} dist.,
                                        {data?.permanent_pincode}
                                    </td>
                                    <td>
                                        Name : &nbsp;{data?.manager_name}, <br />
                                        {data?.manager_mobile},{data?.manager_email},
                                        <br />
                                        Address :  {data?.manager_address}, Door No-{data?.manager_door_no} ,
                                        {data?.manager_village_name},
                                        {data?.manager_mandal_name} ,
                                        {data?.manager_district_name} dist.,
                                        {data?.manager_pincode}
                                    </td>

                                </tr>

                            </React.Fragment>
                        </tbody>

                    </table>
                    <div className="inner-herbpage-service-title-sub">
                        <h1 style={{ fontSize: "18px" }}>Other establishments</h1>
                    </div>
                    <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
                        style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }}>
                        <tbody>
                            <tr><th>Category of Establishment</th> <td>{data?.establishment_category}</td>
                                <th>Nature of Construction</th> <td>{data?.nature_of_construction}</td> </tr>
                            <tr><th>Date of Commencement of Construction</th> <td>{data?.date_of_commencement}</td>
                                <th>Probable Date of Completion</th> <td>{data?.date_of_completion}</td> </tr>
                            <tr><th>Constructed area(plinth area in sq. Mts)</th> <td>{data?.constructed_area}</td>
                                <th>Basis for estimation</th> <td>{data?.nature_of_construction}</td> </tr>
                            <tr><th>Plan Approval No.</th> <td>{data?.plan_approval}</td>
                                <th>No. of workers</th> <td>{data?.no_of_workers}</td> </tr>
                        </tbody>
                    </table>


                    <div className="inner-herbpage-service-title-sub">
                        <h1 style={{ fontSize: "18px" }}>Payment Status</h1>
                    </div>
                    <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
                        style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }}>
                        <thead>


                        </thead>
                        <tbody>
                            <tr>
                                <th colSpan={3}>Estimated Cost Of Construction</th>
                                <th colSpan={3}>Cess Amount (1 % of Estimated Cost) </th>
                            </tr>
                            <tr>
                                <th>Total</th>
                                <th>Paid</th>
                                <th>To Be Paid</th>
                                <th>Total</th>
                                <th>Paid</th>
                                <th>To Be Paid</th>
                            </tr>
                            <tr>
                                <td style={{ textAlign: "center", fontSize: "15px", backgroundColor: "#ffe6e6" }} className="text-right">{paymentStatusData?.est_cost_of_construction}</td>
                                <td style={{ textAlign: "center", fontSize: "15px", backgroundColor: "#ffe6e6" }} className="text-right">{paymentStatusData?.further_cost_paid}</td>
                                <td style={{ textAlign: "center", fontSize: "15px", backgroundColor: "#ffe6e6" }} className="text-right">{paymentStatusData?.further_cost_to_be_paid}</td>
                                <td style={{ textAlign: "center", fontSize: "15px", backgroundColor: "#ffe6e6" }} className="text-right">{paymentStatusData?.tot_cess}</td>
                                <td style={{ textAlign: "center", fontSize: "15px", backgroundColor: "#ffe6e6" }} className="text-right">{paymentStatusData?.cess_paid}</td>
                                <td style={{ textAlign: "center", fontSize: "15px", backgroundColor: "#ffe6e6" }} className="text-right">{paymentStatusData?.cess_to_be_paid}</td>
                            </tr>
                        </tbody>
                    </table>
                    {transactionData?.length > 0 ? <>
                        <div className="inner-herbpage-service-title-sub">
                            <h1 style={{ fontSize: "18px" }}>Transaction Data</h1>
                        </div>
                        <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
                            style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }}>
                            <thead>
                                <tr>
                                    <th>Cost for Construction</th>
                                    <th>Cess Amount</th>
                                    <th>Payment Type</th>
                                    <th>Pyament Status</th>
                                </tr>

                            </thead>
                            <tbody>
                                {transactionData?.map((data, index) => {
                                    return (
                                        <tr key={index} id={index}>
                                            <td >{data?.further_cost}</td>
                                            <td >{data?.cess_amount}</td>
                                            <td >{data?.payment_type}</td>
                                            <td >{data?.payment_status}</td>

                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </> : ""}

                </div>
            </jnb.Container>
        </React.Fragment>
    )
}
